export default __webpack_public_path__ + "logo.f6372168e26a914d65d870a4c55642e0.svg";